import Card from "../../card/Card";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import SoulStone from "../../../images/main_menu/soul_stone.png";
import React from "react";
import {sounds} from "../../../sounds/sound";
import {useActions} from "../../../hooks/useActions";
import DivineEssence from "../../../images/main_menu/divine_essence.png";

function WorkShopCardSlide({user, card, amount, canCraftCard = false}) {

    const {craftCard, updateUser, setSystemMessage} = useActions();
    const {isLoading} = useTypedSelector(state => state.auth);

    const price: Record<number, number> = {
        1: 75,
        2: 150,
        3: 300,
        4: 10
    };

    const cardPrice = price[card.level];

    return <div className={"workshopCard"}>


        <Card card={card} AmountNum={amount}/>


        {canCraftCard ?

            <div className={'workshopBuyButton'} onClick={async () => {
                if (isLoading) {
                    return;
                }
                const isDivine = card.level === 4;

                const currency = isDivine ? user.divine_essence : user.soul_stone;
                const notEnoughText = isDivine
                    ? 'Not enough Divine Essence!'
                    : 'Not enough Soul Stones!';

                if (cardPrice <= currency) {
                    await craftCard(card.id, updateUser);
                    sounds.open_box().play();
                } else {
                    setSystemMessage({
                        isVisible: true,
                        type: 'info',
                        text: notEnoughText,
                        action: null
                    });
                }

            }}>
                {cardPrice}
                {(card.level === 4) ?
                    <img className='workshopSoulStone' src={DivineEssence as any} alt={'Divine Essence'}/>
                    :
                    <img className='workshopSoulStone' src={SoulStone as any} alt={'Soul Stone'}/>
                }

            </div>
            : <div></div>
        }
    </div>


}

export default WorkShopCardSlide;
